import { FormDefinition, FieldDefinition } from "../Components/Form/Form";
import { basic_text_validator, boolean_selection_validator, selection_validator } from "./formFieldValidators";
import { needHelpWithDefinition } from "./profileFormDefitions";
import * as T from "./frontendTypes";

export const getNeedHelpFormDef = (founderProfile: T.StartupFounderProfile, regionalFirmOptions: {value: string, text: string}[]) => {
    const regionalFirmSelectionData = () => {
      const array: {value: string, text: string, frText?: string}[] = []
      regionalFirmOptions.forEach((item) => (
        array.push(
          {value: item.value,
          text: item.text,
          }
        )
      ))
      array.push({value: "Other", text: "Other", frText: "Autre"})
      return array
    }

    let modifiedForm = { ...needHelpWithDefinition };
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "topics";
      const newValue: FieldDefinition = {
          label: "Please select the topics that you'd like to discuss with our IP Advisor:",
          frLabel: "Veuillez sélectionner les sujets dont vous aimeriez discuter avec notre conseiller en PI :",
          inputType: "multiSelect",
          validator: selection_validator,
          conditionalRenderDefinition: {
            fieldKey: "businessGoal",
            renderWhenTrue: true,
          },
          additionalData: {
            selectionData: [
              {
                value: "Patents",
                text: "Patents",
                frText: "Brevets",
              },
              {
                value: "Industrial Designs/ Design Patents",
                text: "Industrial Designs/ Design Patents",
                frText: "Dessins industriels/brevets de design",
              },
              {
                value: "Trademarks",
                text: "Trademarks",
                frText: "Marques de commerce",
              },
              {
                value: "Trade Secrets",
                text: "Trade Secrets",
                frText: "Secrets commerciaux",
              },
              {
                value: "Copyright",
                text: "Copyright",
                frText: "Droit d'auteur",
              },
              {
                value: "Open Source Asset Use",
                text: "Open Source Asset Use",
                frText: "Utilisation d'actifs en code source ouvert",
              },
              {
                value: "IP Strategy",
                text: "IP Strategy",
                frText: "Stratégie de PI",
              },
              {
                value: "IP Ownership",
                text: "IP Ownership",
                frText: "Propriété de la PI",
              },
              {
                value: "Freedom to Operate",
                text: "Freedom to Operate",
                frText: "Liberté d'exploitation",
              },
              {
                value: "Review Prior Art",
                text: "Review Prior Art",
                frText: "Examen de l'art antérieur",
              },
            ]
          },
      };

      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "businessGoal") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "specificDiscussion";
      const newValue: FieldDefinition = {
        label: "Without specifically referencing IP sensitive information, please provide a general overview of what you' like to discuss with our IP Advisor",
        frLabel: "Sans faire spécifiquement référence à des renseignements sensibles en matière de PI, veuillez fournir un aperçu général de ce dont vous aimeriez discuter avec notre conseiller en PI",
        inputType: "textarea",
        conditionalRenderDefinition: {
          fieldKey: "businessGoal",
          renderWhenTrue: true,
        },
        validator: basic_text_validator
      };

      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "topics") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Other")) {
      const newKey = "activitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator
      };

      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Patent Filing")) {
      const newKey = "patentsReadyOptions";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:",
        frLabel: "Si vous pensez être prêt à déposer des brevets dans les 3 à 6 prochains mois, veuillez indiquer lesquels des énoncés suivants s'appliquent à la technologie que vous souhaitez breveter :",
        inputType: "multiSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              frText: "Mon fournisseur de services en PI a effectué une recherche favorable de brevetabilité/art antérieur/nouveauté pour la technologie que je prévois breveter.",
            },
            {
              value: "I have a granted patent in the same patent family.",
              text: "I have a granted patent in the same patent family.",
              frText: "J'ai un brevet accordé dans la même famille de brevets.",
            },
            {
              value: "I have received a favorable written opinion from my PCT application.",
              text: "I have received a favorable written opinion from my PCT application.",
              frText: "J'ai reçu un avis écrit favorable de ma demande PCT.",
            },
          ]
        },
      };
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Trademark Filing")) {
      const newKey = "searchCompleted";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        frLabel: "Si vous pensez être prêt à enregistrer des marques dans les 3 à 6 prochains mois, votre fournisseur de services en PI a-t-il effectué une recherche de disponibilité?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            { value: "yes", text: "Yes", frText: "Oui" },
            { value: "no", text: "No", frText: "Non" },
          ]
        },
      };

      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.length > 0 && founderProfile.needHelpWith.exclusiveRights) {
      const newKey = "exclusiveRights";
      const newValue: FieldDefinition = {
        label: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
        frLabel: "Si la propriété de votre PI est partagée (p. ex. avec un établissement universitaire), avez-vous les droits exclusifs de commercialiser la technologie?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            { value: "yes", text: "Yes", frText: "Oui" },
            { value: "no", text: "No", frText: "Non" },
            { value: "n/a", text: "N/A", frText: "S.O." }
          ]
        },
      };

      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.exclusiveRights === "no") {
      const newKey = "ipOwnerName";
      const newValue: FieldDefinition = {
        label: "Who is the owner?",
        frLabel: "Qui est le propriétaire?",
        inputType: "text",
        validator: basic_text_validator
      };

      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "exclusiveRights") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm) {
        const newKey = "firmId";
        const newValue: FieldDefinition = {
          label: `Please select the firm (select "Other" if your current firm is not listed)`,
          frLabel: `Veuillez sélectionner la firme (sélectionnez « Autre » si votre firme actuelle ne figure pas dans la liste)`,
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: regionalFirmSelectionData()
          },
          };

        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "workingWithFirm") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm && founderProfile.needHelpWith.firmId === "Other" && founderProfile.needHelpWith.firmOther) {
        const newKey = "firmOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator
        };

        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "firmId") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport) {
        const newKey = "supportOrg";
        const newValue: FieldDefinition = {
          label: `Please select which organization:`,
          frLabel: "Veuillez préciser quelle organisation:",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "Intellectual Property Ontario (IPON)",
                text: "Intellectual Property Ontario (IPON)",
                frText: "Propriété intellectuelle Ontario (IPON)",
              },
              {
                value: "NRC IP Assist",
                text: "NRC IP Assist",
                frText: "Aide en PI du CNRC",
              },
              {
                value: "IAC",
                text: "IAC",
                frText: "IAC",
              },
              {
                value: "ElevateIP",
                text: "ElevateIP",
                frText: "ÉleverlaPI",
              },
              {
                value: "Other",
                text: "Other",
                frText: "Autre",
              }
            ]
          },
        };

        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "govtSupport") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport && founderProfile.needHelpWith.supportOrg === "Other" && founderProfile.needHelpWith.supportOrgOther) {
        const newKey = "supportOrgOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator
        };

        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "supportOrg") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

    return modifiedForm
  }
